import { initCartChangesHook } from './cartChanges';

export default function initCartHandler() {
  initCartChangesHook();
}
